import styled from 'styled-components'

export const CardsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  max-width: 520px;
`

export const CardFrame = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 520 / 330;
  container-type: inline-size;
`

export const CardSide = styled.div<{ $variant: 'front' | 'back' }>`
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: 16px;
  color: #fff;
  font-family: 'Quicksand', 'Nunito', Arial, sans-serif;
  line-height: 1.2;
  background: ${({ $variant }) =>
    $variant === 'front'
      ? 'linear-gradient(135deg, #34495e 0%, #1f2b38 100%)'
      : 'linear-gradient(135deg, #14b89a 0%, #02ad92 100%)'};

  * {
    box-sizing: border-box;
    font-family: inherit;
    line-height: inherit;
  }
`

export const FrontContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  padding: 4cqw 5cqw;

  img {
    height: 11cqw;
    width: auto;
  }
`

export const CardTitle = styled.h3`
  margin: 2.5cqw 0 0;
  font-size: 4.4cqw;
  font-weight: 700;
  letter-spacing: 0.08em;
  color: #fff;
`

export const CardSubtitle = styled.p`
  margin: 0.4cqw 0 0;
  font-size: 2.6cqw;
  letter-spacing: 0.05em;
  color: #1fb5a0;
`

export const InfoBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.6cqw;
  width: 100%;
  margin-top: 2.6cqw;
  padding: 2.4cqw 2.6cqw;
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 4cqw;
  background: rgba(255, 255, 255, 0.04);
`

export const InfoRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2cqw;
`

export const InfoItem = styled.div<{ $full?: boolean }>`
  min-width: 0;
  grid-column: ${({ $full }) => ($full ? '1 / -1' : 'auto')};
  padding-bottom: 1cqw;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);

  span {
    display: block;
    font-size: 2cqw;
    letter-spacing: 0.22em;
    color: #19c3e0;
  }

  strong {
    display: block;
    margin-top: 0.6cqw;
    overflow: hidden;
    font-size: 3.5cqw;
    font-weight: 600;
    color: #fff;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`

export const BackContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 3cqw 3cqw 1.6cqw;
`

export const BackPanels = styled.div`
  display: grid;
  flex: 1;
  grid-template-columns: minmax(0, 1.45fr) minmax(0, 1fr);
  gap: 2.2cqw;
  min-height: 0;
`

export const Panel = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
  padding: 2.4cqw 2.6cqw;
  border-radius: 3cqw;
  background: rgba(255, 255, 255, 0.14);

  h4 {
    margin: 0 0 1.8cqw;
    font-size: 2.6cqw;
    white-space: nowrap;
    font-weight: 700;
    color: #fff;
  }
`

export const ContactList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 0.9cqw;
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: 2.1cqw;

  li {
    margin: 0;
    white-space: nowrap;
  }

  strong {
    margin-right: 1cqw;
    font-weight: 700;
  }
`

export const Compliance = styled.div`
  display: flex;
  margin-top: 1.8cqw;
  overflow: hidden;
  border-left: 1cqw solid #fff;
  border-radius: 2.4cqw;
  background: rgba(255, 255, 255, 0.16);

  > div {
    padding: 1.4cqw 1.8cqw;
  }

  strong {
    display: block;
    font-size: 1.9cqw;
  }

  p {
    margin: 0.4cqw 0 0;
    font-size: 1.65cqw;
  }
`

export const ComplianceNote = styled.div`
  margin-top: 1cqw;
  padding: 0.8cqw 1.2cqw;
  border-left: 0.7cqw solid #f2d600;
  border-radius: 1cqw;
  background: rgba(255, 255, 255, 0.16);
  font-size: 1.45cqw;
  font-weight: 700;
`

export const QrList = styled.div`
  display: flex;
  justify-content: space-around;
  gap: 2cqw;
`

export const QrItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1cqw;
  font-size: 2.2cqw;

  div {
    display: flex;
    padding: 1cqw;
    border-radius: 2cqw;
    background: #fff;
  }

  svg {
    width: 11.5cqw;
    height: 11.5cqw;
  }
`

export const UrlList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8cqw;
  margin-top: auto;

  span {
    overflow: hidden;
    padding: 0.6cqw 1.2cqw;
    border-radius: 1cqw;
    background: rgba(255, 255, 255, 0.16);
    font-size: 1.55cqw;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`

export const BackFooter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.6cqw;
  padding-top: 1.4cqw;

  strong {
    padding: 0.6cqw 2.6cqw;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.2);
    font-size: 2.1cqw;
  }

  small {
    font-size: 1.5cqw;
    opacity: 0.7;
  }
`

export const DownloadButton = styled.button`
  align-self: flex-start;
  min-width: 180px;
  padding: 0.7rem 1.25rem;
  border: 0;
  border-radius: 8px;
  background: #02b0bb;
  color: #fff;
  font-size: 1rem;
  font-weight: 700;
  cursor: pointer;

  &:hover:not(:disabled) {
    background: #029aa4;
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
`
